const getStarted = {
    getStarted: {
      pageTitle: 'Get Started',
      pageDescription: 'IOPS 지상국을 통해 위성과 통신하고, 위성 관측 데이터를 송수신하며 데이터를 다운링크하세요.',
  
      button: {
        tutorial: 'Tutorial'
      },
  
      step: {
        1: {
          title: '위성 관리',
          subtitle: 'STEP1',
          description: '등록된 위성 정보를 확인하고 관리하세요.'
        },
        2: {
          title: '교신 프로필 설정',
          subtitle: 'STEP2',
          description: '교신 프로필을 정의하고 관리하세요.'
        },
        3: {
          title: '스케줄 예약',
          subtitle: 'STEP3',
          description: '지상국에서 위성과 통신할 교신 시간을 예약하세요.'
        }
      }
    }
  };
  
  export default getStarted;
  